import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { defaultCarleadCreationConfig } from '../../../default/configuration';

const extendedCarleadCreationConfig = {
  ...defaultCarleadCreationConfig,
  step2Path: '/{currentPath}/step-2/',
};

export default generateCarleadCreationConfig(extendedCarleadCreationConfig);

